import React from "react";
import ControlDetailsPanel from "./ControlDetailsPanel";
import { IControlSound } from "../types";

interface IControlDetailsSoundProps {
  control: IControlSound;
}

const ControlDetailsSound = (props: IControlDetailsSoundProps) => {
  const { control } = props;
  return (
    <ControlDetailsPanel
      mode={control.is_enabled ? "on" : "disabled"}
      title={control.name}
    ></ControlDetailsPanel>
  );
};

export default ControlDetailsSound;
